import { render, staticRenderFns } from "./HotpAudio.vue?vue&type=template&id=09781bcd&scoped=true"
import script from "./HotpAudio.vue?vue&type=script&lang=js"
export * from "./HotpAudio.vue?vue&type=script&lang=js"
import style0 from "./HotpAudio.vue?vue&type=style&index=0&id=09781bcd&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09781bcd",
  null
  
)

export default component.exports